export default {
  "wt-popup": "_wt-popup_1i1fxsl_3",
  "wt-popup__overlay": "_wt-popup__overlay_1i1fxsl_54",
  "wt-popup__close_embedded": "_wt-popup__close_embedded_1i1fxsl_66",
  "wt-popup__header": "_wt-popup__header_1i1fxsl_74",
  "wt-popup__close_header": "_wt-popup__close_header_1i1fxsl_74",
  "wt-popup__content": "_wt-popup__content_1i1fxsl_96",
  "wt-popup__footer": "_wt-popup__footer_1i1fxsl_122",
  "wt-popup__loading-icon": "_wt-popup__loading-icon_1i1fxsl_134"
};